import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  Notification as NotificationType,
  UnverifiedEmailNotificationMessage,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: UnverifiedEmailNotificationMessage;
  onClick: (notification: NotificationType) => void;
};

const UnverifiedEmailNotification = ({ notification, onClick }: Props) => {
  const {
    data: { email },
  } = notification;

  const header = (
    <>
      <b>{_t('Verify your recovery email')}</b>
      <br />
    </>
  );

  return (
    <Notification onClick={onClick} notification={notification} href="/account-setting">
      <FormattedHTMLMessage
        message={_t(
          '{header} We sent a verification email to {email}. Check your inbox to confirm your recovery email. To update your email, go to your account settings.'
        )}
        header={header}
        email={<b>{email}</b>}
      />
    </Notification>
  );
};

export default UnverifiedEmailNotification;
